/* eslint-disable */
import Vue from 'vue'
import { ValidationProvider, extend, ValidationObserver } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import en from 'vee-validate/dist/locale/en'

for (const rule in rules) {
  extend(rule, {
    ...rules[rule],
    message: en.messages[rule],
  })
}
extend('decimal', {
  params: ['decimals'],
  validate: (value, { decimals = '*', separator = '.' } = {}) => {
    if (value === null || value === undefined || value === '') {
      return {
        valid: false,
      }
    }
    if (Number(decimals) === 0) {
      return {
        valid: /^-?\d*$/.test(value),
      }
    }
    const regexPart = decimals === '*' ? '+' : `{1,${decimals}}`
    const regex = new RegExp(
      `^[-+]?\\d*(\\${separator}\\d${regexPart})?([eE]{1}[-]?\\d+)?$`
    )

    return {
      valid: regex.test(value),
    }
  },
  message: 'The {_field_} field must contain only decimal values',
})

extend('validateName', {
  validate: value => {
    const regex = /^[a-zA-Zก-๙()\s]+$/
    let validateResult = regex.test(value)
    return validateResult
  },
  message: fiedName => {
    return app.i18n.t('validate.validate_name').replace('{fieldName}', fiedName)
  },
})

extend('url', {
  validate(value) {
    if (value) {
      return /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/.test(
        value
      )
    }

    return false
  },
  message: 'กรุณาระบุเป็น URL เท่านั้น',
})

extend('validateEng', {
  validate(value) {
    var letters = /^[ A-Za-z\s]+$/
    if (value) {
      return letters.test(value)
    }

    return false
  },
  message: 'กรุณาระบุเป็นภาษาอังกฤษเท่านั้น',
})

extend('validateEngWithSpecialCharacters', {
  validate(value) {
    var letters = /^[ '"A-Za-z_0-9@./#,;:()<>$!%?&+-]*$/i
    if (value) {
      return letters.test(value)
    }

    return false
  },
  message: 'กรุณาระบุเป็นภาษาอังกฤษเท่านั้น',
})

extend('validateEngUpperCase', {
  validate(value) {
    var letters = /^[ A-Z\s]+$/
    if (value) {
      return letters.test(value)
    }

    return false
  },
  message: 'กรุณาระบุภาษาอังกฤษตัวพิมพ์ใหญ่เท่านั้น',
})

extend('validateThai', {
  validate(value) {
    var letters = /^[ ก-๙\s]+$/
    if (value) {
      return letters.test(value)
    }

    return false
  },
  message: 'กรุณาระบุเป็นภาษาไทยเท่านั้น',
})

extend('validateThaiWithSpecialCharacters', {
  validate(value) {
    var letters = /^[ '"ก-๙_0-9@./#,;:()<>$!%?&+-]*$/i
    // var letters = /^[@ก-๙0-9-\s]+$/;
    if (value) {
      return letters.test(value)
    }

    return false
  },
  message: 'กรุณาระบุเป็นภาษาไทยเท่านั้น',
})

extend('validateNum2Decimal', {
  validate(value) {
    var letters = /^\d*(\.\d{0,2})?$/
    if (value) {
      return letters.test(value)
    }

    return false
  },
  message: 'กรุณาระบุเป็นตัวเลขทศนิยม 2 ตำแหน่งเท่านั้น',
})

extend('validateNumDecimal', {
  validate(value) {
    var letters = /^\d*(\.\d{0,1})?$/
    if (value) {
      return letters.test(value)
    }

    return false
  },
  message: 'กรุณาระบุเป็นตัวเลขทศนิยม 1 ตำแหน่งเท่านั้น',
})

extend('validateNum', {
  validate(e) {
    e = e || window.event
    if (
      (e.key >= 0 && e.key <= 9) ||
      (e.keyCode >= 96 && e.keyCode <= 105) ||
      e.keyCode === 8 ||
      e.keyCode === 9 ||
      e.keyCode === 13 ||
      e.keyCode === 46 ||
      e.keyCode === 37 ||
      e.keyCode === 39
    ) {
      return false
    } else {
      return e.preventDefault()
    }
  },
  message: 'กรุณาระบุตัวเลขเท่านั้น',
})

extend('validateDisplayNameObjectEng', {
  validate(value) {
    if (value.display_name.en !== '') {
      return true
    }

    return false
  },
  message: 'กรุณาเลือก',
})

extend('validateSingleQuote', {
  validate(value) {
    if (value.indexOf("'") == -1) {
      return true
    }

    return false
  },
  message: "ชื่อสินค้า ไม่สามารถให้มีเครื่องหมาย ' (Single Quote) ได้",
})

extend('duplicateName', {
  // **Rule For validate duplicate name from restful api method Head
  validate(value, { validateFlag, msg }) {
    return !validateFlag
  },
  params: ['validateFlag', 'msg'],
  message: (fieldName, objProvider) => {
    return objProvider.msg
  },
})

extend('dynamicRequired', {
  ...rules.required,
  params: ['msg'],
  message: (fieldName, objProvider) => {
    return objProvider.msg
  },
})

extend('validateWarehouseSelector', {
  validate(value) {
    if (value && value.warehouse_id !== '') {
      return true
    }

    return false
  },
  message: 'เลือกคลังสินค้า',
})

extend('validateSubWarehouseSelector', {
  validate(value) {
    if (value && value.sub_warehouse_id !== '') {
      return true
    }

    return false
  },
  message: 'เลือกคลังสินค้าย่อย',
})

Vue.component('validationProvider', ValidationProvider)
Vue.component('validationObserver', ValidationObserver)
